import React from "react";
import { useForm, useFieldArray } from "react-hook-form";

const HoursForm = ({ hours, onSave, onCancel }) => {
    const { control, register, handleSubmit } = useForm({
        defaultValues: { hours }
    });

    const { fields } = useFieldArray({
        control,
        name: "hours"
    });

    const submit = (data) => {
        onSave(data.hours);
    };

    return (
        <form onSubmit={handleSubmit(submit)}>
            <div className="table-responsive">
                <table className="table table-striped align-middle">
                    <thead>
                    <tr>
                        <th>Day</th>
                        <th>Start</th>
                        <th>End</th>
                        <th>Status</th>
                        <th>Note</th>
                    </tr>
                    </thead>
                    <tbody>
                    {fields.map((field, index) => (
                        <tr key={field.id}>
                            <td>{field.day}</td>
                            <td>
                                <input
                                    type="text"
                                    className="form-control"
                                    {...register(`hours.${index}.start`)}
                                />
                            </td>
                            <td>
                                <input
                                    type="text"
                                    className="form-control"
                                    {...register(`hours.${index}.end`)}
                                />
                            </td>
                            <td>
                                <select
                                    className="form-select"
                                    {...register(`hours.${index}.status`)}
                                >
                                    <option value={true}>Open</option>
                                    <option value={false}>Closed</option>
                                </select>
                            </td>
                            <td>
                                <input
                                    type="text"
                                    className="form-control"
                                    {...register(`hours.${index}.note`)}
                                />
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
            <div className="d-flex justify-content-end gap-2 mt-3">
                <button type="button" className="btn btn-outline-secondary" onClick={onCancel}>
                    Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                    Save Changes
                </button>
            </div>
        </form>
    );
};

export default HoursForm;
